export { Popup as DeleteMerchantPopup } from './popup'
